// components/notes/NotesFAB.jsx
import styled from "styled-components";
import { NotebookPen } from "lucide-react";
import { useNotesModal } from "../../context/NotesModalContext";

const Fab = styled.button`
  position: fixed;
  bottom: 104px;
  right: 24px;

  display: flex;
  align-items: center;
  gap: 12px;

  padding: 12px 14px 12px 12px;
  border-radius: 22px;

  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.94), rgba(2, 6, 23, 0.92)),
    linear-gradient(135deg, rgba(245, 158, 11, 0.16), rgba(56, 189, 248, 0.14));

  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  border: 1px solid rgba(148, 163, 184, 0.18);

  color: #e5e7eb;

  cursor: pointer;
  z-index: 998;

  box-shadow: 0 20px 44px rgba(2, 6, 23, 0.34),
    inset 0 0 0 1px rgba(255, 255, 255, 0.04);

  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-3px) scale(1.02);
    border-color: rgba(56, 189, 248, 0.26);
    box-shadow: 0 24px 56px rgba(2, 6, 23, 0.46),
      inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  }

  &:active {
    transform: scale(0.97);
  }

  @media (max-width: 640px) {
    bottom: 92px;
    padding: 12px;
    border-radius: 18px;
  }
`;

const IconWrap = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(135deg, #f59e0b, #38bdf8);
  color: #04111f;
  border: 1px solid rgba(255, 255, 255, 0.08);

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
`;

const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 640px) {
    display: none;
  }
`;

const Kicker = styled.div`
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7dd3fc;
`;

const Label = styled.div`
  margin-top: 2px;
  font-size: 14px;
  font-weight: 900;
  color: #f8fafc;
`;

const Hint = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;

  @media (max-width: 920px) {
    display: none;
  }
`;

export default function NotesFAB() {
  const { setOpen } = useNotesModal();

  return (
    <Fab onClick={() => setOpen(true)}>
      <IconWrap>
        <NotebookPen size={18} />
      </IconWrap>

      <LabelWrap>
        <Kicker>Knowledge Base</Kicker>
        <Label>Saved Notes</Label>
        <Hint>Keep important insights close</Hint>
      </LabelWrap>
    </Fab>
  );
}
